const bar = document.getElementById("sticky-register-bar");
const hero = document.querySelector("[data-on-tour-hero]");
const nav = document.getElementById("navigation");

if (bar && hero) {
  function updateBarTop() {
    const top = nav ? nav.getBoundingClientRect().bottom : 48;
    bar.style.top = Math.max(0, top) + "px";
  }
  updateBarTop();
  window.addEventListener("scroll", updateBarTop, { passive: true });
  window.addEventListener("resize", updateBarTop);

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          bar.classList.add("opacity-0", "pointer-events-none");
          bar.classList.remove("opacity-100", "pointer-events-auto");
          bar.setAttribute("aria-hidden", "true");
        } else {
          bar.classList.remove("opacity-0", "pointer-events-none");
          bar.classList.add("opacity-100", "pointer-events-auto");
          bar.setAttribute("aria-hidden", "false");
        }
      });
    },
    { threshold: 0.15 },
  );
  observer.observe(hero);
}
